<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="mt-5">
    <div class="vx-row">
      <div class="vx-col md:w-1/1 w-full mt-5">
        <vx-card
          v-if="Defaulter == 'Y'"
          icon="DollarSignIcon"
          icon-right
          title="Atenção"
          title-color="#fff"
          card-background="danger"
          content-color="#fff"
        >
          <p class="mb-3">
            Este cliente é inadimplente não é possivel continuar.
          </p>
        </vx-card>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  components: {},
  props: {
    Defaulter: {
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
     isDefaulter(defaulter) {
      console.log(defaulter)
      if (defaulter == "Y") return true;
      else return false;
    },
  },
  async created() {},
};
</script>


